import Vue from 'vue'
import Router from 'vue-router'
// import Hello from '@/components/Hello'

import NavMenu from '@/page/navMenu'

import AccountMgr from '@/page/accountMgr/index'
// import DeviceMgr from '@/page/deviceMgr/index'
import DeviceBind from '@/page/deviceMgr/deviceBind'
import DeviceNoBind from '@/page/deviceMgr/deviceNoBind'
import AlarmSummary from '@/page/deviceMgr/alarmSummary'

import VersionMgr from '@/page/versionMgr/index'
import withdrawRecord from '@/page/financeMgr/withdrawRecord'
import checkRecord from '@/page/financeMgr/checkRecord'
// import AdMgr from '@/page/adMgr/index'
import AdPic from '@/page/adMgr/adPic'
import AdVideo from '@/page/adMgr/adVideo'
import AdWeixin from '@/page/adMgr/adWeixin'

import DeviceEntryAddress from '@/page/adMgr/deviceEntryAddress'
import AddEntryAddress from '@/page/adMgr/addEntryAddress'
import EntryQrcodeDeviceList from '@/page/adMgr/entryQrcodeDeviceList'

// import DataStatistics from '@/page/dataStatistics/index'
import DataDevice from '@/page/dataStatistics/dataDevice'
import DataWeixin from '@/page/dataStatistics/dataWeixin'
import DataOutGoods from '@/page/dataStatistics/outGoods'
import DataDeviceOutGoods from '@/page/dataStatistics/deviceOutGoods'

import PayStatus from '@/page/globalConfig/payStatus'
//import splashConfig from '@/page/globalConfig/splashConfig'
import flowConfig from '@/page/globalConfig/flowConfig'

import UserFlowConfig from '@/page/globalConfig/userException'
import DeviceFlowConfig from '@/page/globalConfig/deviceException'

// import lookinfo from '@/page/deviceInfo'
import LookAcc from '@/page/deviceInfo/lookAccount'
import LookUserInfo from '@/page/deviceInfo/wxUserInfo'
import editPwd from '@/page/accountMgr/editPwd'
import withdraw from '@/page/financeMgr/withdraw'
import incomeFlow from '@/page/financeMgr/incomeFlow'

import PersonalCenter from '@/page/accountMgr/personalCenter'

import FxLevel from '@/page/fxshop/fxLevel'
import FxCommodityAdd from '@/page/fxshop/fxCommodityAdd'
import FxCommodityList from '@/page/fxshop/fxCommodityList'
import FxTradeRecord from '@/page/fxshop/fxTradeRecord'
import FxGallery from '@/page/fxshop/fxGallery'
import FxShareFee from '@/page/fxshop/fxShareFee'
import FxTradeOrderDetail from '@/page/fxshop/fxTradeOrderDetail'

import FxShopInfo from '@/page/fxshop/fxShopInfo'

import FxIncomeSubsidy from '@/page/fxshop/fxIncomeSubsidy'
import FxIncomeCommission from '@/page/fxshop/fxIncomeCommission'
import FxIncomeCommissionWithdraw from '@/page/fxshop/fxIncomeCommissionWithdraw'


import MutiGoodsAdd from '@/page/mutiGoods/mutiGoodsAdd'
import MutiGoodsList from '@/page/mutiGoods/mutiGoodsList'

import OpRecord from '@/page/opMgr/opRecord'
import GpsRecord from '@/page/opMgr/gpsRecord'


import Login from '@/page/login'

Vue.use(Router)

let router = new Router({
  routes: [
    {
      path: '/login',
      name: '登录',
      component: Login
    },
    {
      path: '/',
      name: 'navMenu',
      component: NavMenu,
      leaf: true, // 只有一个节点
      redirect: '/accountMgr',
      children: [
        {
          path: '/accountMgr',
          component: AccountMgr,
          name: '账户管理',
          menuShow: true
        },
        {
          path: '/deviceMgr',
          name: '设备管理'
        },
        {
          path: '/deviceMgr/deviceBind',
          component: DeviceBind,
          name: '已绑定设备',
          menuShow: true
        },
        {
          path: '/deviceMgr/deviceNoBind',
          component: DeviceNoBind,
          name: '未绑定设备',
          menuShow: true
        },
        {
          path: '/deviceMgr/alarmSummary',
          component: AlarmSummary,
          name: '告警汇总',
          menuShow: true
        },
        {
          path: '/adMgr',
          name: '广告管理'
        },
        {
          path: '/adMgr/adPic',
          component: AdPic,
          name: '图片广告',
          menuShow: true
        },
        {
          path: '/adMgr/adVideo',
          component: AdVideo,
          name: '视频广告',
          menuShow: true
        },
        {
          path: '/adMgr/adWeixin',
          component: AdWeixin,
          name: '微信广告',
          menuShow: true
        },
        {
          path: '/adMgr/deviceEntryAddress',
          component: DeviceEntryAddress,
          name: '设备入口地址',
          menuShow: true
        },
        {
          path: '/adMgr/addEntryAddress',
          component: AddEntryAddress,
          name: '新增入口地址',
          menuShow: true
        },
        {
          path: '/adMgr/entryQrcodeDeviceList',
          component: EntryQrcodeDeviceList,
          name: '设备入口地址',
          menuShow: true
        },
        {
          path: '/dataStatistics',
          name: '数据统计'
        },
        {
          path: '/dataStatistics/dataDevice',
          component: DataDevice,
          name: '设备数据',
          menuShow: true
        },
        {
          path: '/dataStatistics/dataWeixin',
          component: DataWeixin,
          name: '公众号数据',
          menuShow: true
        },
        {
          path: '/dataStatistics/outGoods',
          component: DataOutGoods,
          name: '出货数据',
          menuShow: true
        },
        {
          path: '/dataStatistics/deviceOutGoods',
          component: DataDeviceOutGoods,
          name: '设备出货数据',
          menuShow: true
        },
        
        {
          path: '/globalConfig',
          name: '全局配置'
        },
        {
          path: '/globalConfig/payStatus',
          component: PayStatus,
          name: '取货流程',
          menuShow: true
        },
        {
          path: '/globalConfig/flowConfig',
          component: flowConfig,
          name: '用户取货流程',
          menuShow: true
        },
        {
          path: '/globalConfig/deviceException',
          component: DeviceFlowConfig,
          name: '设备例外流程',
          menuShow: true
        },
        {
          path: '/globalConfig/userException',
          component: UserFlowConfig,
          name: '用户例外流程',
          menuShow: true
        },
        {
          path: '/fxshop',
          name: '分销商城'
        },
        {
          path: '/fxshop/commodityAdd',
          component: FxCommodityAdd,
          name: '添加商品',
          menuShow: true
        },
        {
          path: '/fxshop/commodityList',
          component: FxCommodityList,
          name: '商品列表',
          menuShow: true
        },
        {
          path: '/fxshop/tradeRecord',
          component: FxTradeRecord,
          name: '订单列表',
          menuShow: true
        },
        {
          path: '/fxshop/fxLevel',
          component: FxLevel,
          name: '分销等级配置',
          menuShow: true
        },
        {
          path: '/fxshop/fxGallery',
          component: FxGallery,
          name: '商城画廊',
          menuShow: true
        },
        {
          path: '/fxshop/fxShareFee',
          component: FxShareFee,
          name: '分润设置',
          menuShow: true
        },
        {
          path: '/fxshop/fxTradeOrderDetail',
          component: FxTradeOrderDetail,
          name: '订单详情',
          menuShow: true
        },
        {
          path: '/fxshop/fxIncomeSubsidy',
          component: FxIncomeSubsidy,
          name: '补贴收益',
          menuShow: true
        },
        {
          path: '/fxshop/fxIncomeCommission',
          component: FxIncomeCommission ,
          name: '佣金记录',
          menuShow: true
        },
        {
          path: '/fxshop/fxIncomeCommissionWithdraw',
          component: FxIncomeCommissionWithdraw ,
          name: '佣金提现',
          menuShow: true
        },
        {
          path: '/fxshop/fxShopInfo',
          component: FxShopInfo ,
          name: '商城信息设置',
          menuShow: true
        },
        {
          path: '/mutiGoods',
          name: '多商品配置'
        },
        {
          path: '/mutiGoods/mutiGoodsAdd',
          component: MutiGoodsAdd,
          name: '添加商品',
          menuShow: true
        },
        {
          path: '/mutiGoods/mutiGoodsList',
          component: MutiGoodsList,
          name: '商品列表',
          menuShow: true
        },
        {
          path: '/opMgr/opRecord',
          component: OpRecord,
          name: '运维记录',
          menuShow: true
        },
        {
          path: '/opMgr/gpsRecord',
          component: GpsRecord,
          name: '轨迹管理',
          menuShow: true
        },
        {
          path: '/versionMgr',
          component: VersionMgr,
          name: '版本管理',
          menuShow: true
        },
        {
          path: '/financeMgr/withdrawRecord',
          component: withdrawRecord,
          name: '提现记录',
          menuShow: true
        },
        {
          path: '/financeMgr/checkRecord',
          component: checkRecord,
          name: '审核记录',
          menuShow: true
        },
        {
          path: '/financeMgr/withdraw',
          component: withdraw,
          name: '提现',
          menuShow: true
        },
        {
          path: '/financeMgr/incomeFlow',
          component: incomeFlow,
          name: '收入流水',
          menuShow: true
        },
        {
          path: '/personalCenter',
          component: PersonalCenter,
          name: '个人中心',
          menuShow: true
        },
        {
          path: '/accountMgr/editPwd',
          component: editPwd,
          name: '修改密码',
          menuShow: true
        },
        {
          path: '/deviceInfo/lookAccount',
          component: LookAcc,
          name: '账号信息',
          menuShow: true
        },
        {
          path: '/deviceInfo/wxUserInfo',
          component: LookUserInfo,
          name: '详细信息',
          menuShow: true
        }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  

  if (to.path === '/login') {
    window.sessionStorage.removeItem('lbz-device-user-info')
    next()
  } else {
    let user = JSON.parse(window.sessionStorage.getItem('lbz-device-user-info'))
    if (!user) {
      next({path: '/login'})
    } else {
      console.log(to.path);
      console.log(user.user_type);
      if (to.path=="/accountMgr"&&user.user_type==4 ){
        next({path: '/dataStatistics/outGoods'})
      }

      next()
    }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js